/**
 * Softphone version constants.
 *
 * Which softphone runs is controlled exclusively by the
 * `communicator-softphone-v2` feature flag:
 * - flag enabled  -> new softphone (v2)
 * - flag disabled -> legacy softphone
 *
 * The resolved value is mirrored into the per-user coordinator store so that
 * non-React code can read it synchronously. Until the flag resolves for a
 * browser that has never stored it, we assume the new softphone: it is the
 * default experience and no user action should be required to get it.
 */
export const DEFAULT_IS_NEW_SOFTPHONE_ENABLED = true;
